<script setup>
import { computed, ref } from 'vue';
import _ from '@/lib/lodash';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  label: {
    type: String,
    default() {
      return '';
    },
  },
  placeholder: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  rows: {
    type: Number,
    default() {
      return 1;
    },
  },
  autosize: {
    type: [Object, Boolean],
    default() {
      return false;
    },
  },
  disabled: {
    type: Boolean,
    default() {
      return false;
    },
  },
  resize: {
    type: Boolean,
    default() {
      return false;
    },
  },
  isError: {
    type: Boolean,
    default() {
      return false;
    },
  },
  error: {
    type: [String, Number, Array],
    default() {
      return '';
    },
  },
  errorClearOnChange: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['update:modelValue', 'update:error', 'input']);

//#region data
const focused = ref(false);
//#endregion

//#region computed
const currentError = computed(() => {
  return _.isArray(props.error) ? props.error[0].message : props.error;
});
//#endregion

//#region methods
const handleInput = (value) => {
  emit('update:modelValue', value);

  if (props.errorClearOnChange) {
    emit('update:error', null);
  }
};
const handleFocus = () => {
  focused.value = true;
};
const handleBlur = () => {
  focused.value = false;
};
//#endregion
</script>

<template>
  <div
    :class="[
      'ui-textarea',
      { 'ui-textarea_focus': focused },
      { 'ui-textarea_disabled': disabled },
      { 'ui-textarea_error': currentError || isError },
    ]"
  >
    <UiLabel
      v-if="label"
      :label="label"
    />

    <ElInput
      :class="[
        'ui-textarea__element',
        { 'ui-textarea__element_resize': resize },
      ]"
      :model-value="modelValue"
      :placeholder="placeholder"
      type="textarea"
      :autosize="autosize"
      :rows="rows"
      @blur="handleBlur"
      @focus="handleFocus"
      @input="handleInput"
    />
    <UiHelp
      v-if="currentError"
      :is-error="true"
      :text="currentError"
    />
  </div>
</template>

<style lang="scss">
.ui-textarea {
  width: 100%;

  &__element {
    border-radius: 8px;
    border: 1px solid #e3e3e3;
    padding: 2px;
    .el-textarea__inner{
      box-shadow: none;
      line-height: 1.5;
      padding: 6px 14px;
      font-size: 14px;
      color: #606266;
      font-weight: 400;
      resize: none;
      width: 100%;
      border-radius: 16px;
      outline: none;
      resize: vertical;
    }
  }

  &_error & {
    &__element {
      border-color: #ff5c70;
    }
  }

  &_focus & {
    &__element {
      border-color: var(--color-border);
    }
  }
}
</style>
